import emitter from "@/utils/bus";
import { useUserStore } from "@/store/user";

export const GUEST_WITHDRAW_EMAIL_SUFFIX = "@guest.invalid";

export const guardGuestWithdraw = () => {
  const userStore = useUserStore();
  if (userStore.email && userStore.email.endsWith(GUEST_WITHDRAW_EMAIL_SUFFIX)) {
    emitter.emit("showGuestWithdrawInfo", true);
    return true;
  }
  return false;
};
